import { VisualisationContextProps } from 'widgets/supportVisualisation/Content/VisualisationContentProps';
import React from 'react';
import { WidgetInfo } from 'widgets/WidgetInfo';
import { Card } from '@instinet-analytics/semantic-ui-components';
import LabelValue from 'utils/components/LabelValue/LabelValue';
import classNames from 'classnames';
import { selectLayoutComponents } from 'layout/store/selectors';

export interface WidgetsPanelProps extends VisualisationContextProps {
    selectedWidget?: WidgetInfo;
    onDrilldown: (widget?: WidgetInfo) => void;
}

export default function WidgetsPanel(props: WidgetsPanelProps) {
    const { state, onDrilldown } = props;

    const widgetInfos = state?.state
        ? selectLayoutComponents(state?.state)
        : [];

    if (widgetInfos.length === 0) {
        return <div>None found in state</div>;
    }

    const onSelectWidget = (widgetInfo?: WidgetInfo) => {
        onDrilldown(widgetInfo);
    };
    return (
        <div className={'Widgets'}>
            <Card.Group>{widgetInfos.map(renderWidget)}</Card.Group>
        </div>
    );

    function renderWidget(w: WidgetInfo) {
        return (
            <Card
                key={w.id}
                className={classNames('clickable active')}
                onClick={() => onSelectWidget(w)}
            >
                <Card.Header>{w.type}</Card.Header>
                <Card.Description>
                    <LabelValue value={w.id} />
                </Card.Description>
            </Card>
        );
    }
}
